<template lang="pug">
  fieldset
    div.radio-container
      template(v-for="(option, index) in options")
        input(type="radio" :id="option.id" :name="name" :value="option.value" @change="updateValue")
        label(:key="index" class="radio-label" :for="option.id")
          |{{ option.label }}
    p ※未経験でもお仕事をご紹介できます
</template>

<script>
export default {
  name: "FormRadio",
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true },
    name: { type: String, required: true }
  },
  methods: {
    updateValue: function(e) {
      const id = "Radio";
      const options = this.options.map(item => item.value);
      const result = { id: id, bool: false, message: "" };
      const value = e.target.value;
      if (e.target.value === "") {
        result.message = "経験を選択してください";
      } else if (!options.includes(value)) {
        result.message = "経験の値が不正です";
      } else {
        result.bool = true;
      }
      this.$emit("checkValidate", result);
      this.$emit("input", value);
    }
  }
};
</script>
<style lang="scss" scoped>
.radio-container {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}

p {
  text-align: center;
  padding-bottom: 15px;
}
</style>
